export default "__VITE_ASSET__WX86wo82__"